import { ExceptionTarget } from "~/components/exceptions/types";

export const getTargetFromExceptionType = (
  typename: string,
): ExceptionTarget => {
  switch (typename) {
    case "AssetCheckException":
    case "SpaceCheckException":
      return "check";
    case "AssetAdvisoryException":
    case "SpaceAdvisoryException":
      return "advisory";
    case "AssetCveException":
    case "SpaceCveException":
      return "cve";
    case "ControlsEdge":
      return "control";
    case "AssetFexException":
    case "SpaceFexException":
      return "finding";
    default: {
      return "finding";
    }
  }
};
